// Added by Claude (AI) — 2026-10-03 — helpers to compute totals rows for report tables
import * as XLSX from 'xlsx';
import { roundToTwoDecimals } from './misc';

// Sum of a numeric field over all rows (empty or non-numeric values are ignored).
export const sumBy = (rows, field) =>
    roundToTwoDecimals(rows.reduce((acc, row) => {
        const value = +row[field];
        return Number.isNaN(value) ? acc : acc + value;
    }, 0));

// Ratio of two totals (e.g. kg/h = total kg / total hours), never an average of averages.
export const ratio = (numerator, denominator, multiplier = 1) =>
    denominator ? roundToTwoDecimals((numerator / denominator) * multiplier) : 0;

// Adds a "Total" row at the end of an Excel sheet: the totals under their columns and the label
// in the first column without a total. headers = column ids in the order of the sheet.
export const appendTotalsRow = (ws, headers, totals, label) => {
    const totalsRow = {};
    headers.forEach((id) => {
        if (totals[id] !== undefined && totals[id] !== null) totalsRow[id] = totals[id];
    });
    const labelId = headers.find((id) => totals[id] === undefined);
    if (labelId) totalsRow[labelId] = label;
    XLSX.utils.sheet_add_json(ws, [totalsRow], { header: headers, skipHeader: true, origin: -1 });
};
